/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_UnassignedInputs */

const en_case_history_verb_task_unassigned = /** @type {(inputs: Case_History_Verb_Task_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unassigned`)
};

const pt_br2_case_history_verb_task_unassigned = /** @type {(inputs: Case_History_Verb_Task_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`desatribuída`)
};

/**
* | output |
* | --- |
* | "unassigned" |
*
* @param {Case_History_Verb_Task_UnassignedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_unassigned = /** @type {((inputs?: Case_History_Verb_Task_UnassignedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_UnassignedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_unassigned(inputs)
	return pt_br2_case_history_verb_task_unassigned(inputs)
});